import request from '@/utils/request'

export function getAboutData() {
    return request({
        url: '/aboutmanager/data',
        method: 'post'
    })
}

export default{
    getAboutData
}